export default __webpack_public_path__ + "images/H7.a04ac82.png";